var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apple-login-wrap"},[_c('div',{key:_vm.theme,staticClass:"apple-btn",attrs:{"id":"appleid-signin","data-color":_vm.theme == 'dark' ? 'black' : 'white',"data-type":"sign-in","data-logo-size":"large","data-mode":"center-align","data-border":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }